import React from "react";

const NewBannerHeading = ({ text, textColor, style }) => {
  return (
    <div>
      <div
        className={`relative w-fit lg:border-b-[0.15vw] border-b-[0.5vw] 
      border-[#F77D0D] lg:pb-[0.5vw] pb-[1vw] font-redhatBold 
      lg:text-[3.55vw] md:text-[4.5vw] text-[7vw] lg:leading-[3.5vw] leading-tight ${style}`}
      >
        {/* Transparent overlay */}
        <div className="absolute inset-0 rounded-md pointer-events-none"></div>

        {/* Text above overlay */}
        <h1 className="relative text-white drop-shadow-lg">{text}</h1>
      </div>
    </div>
  );
};

export default NewBannerHeading;
